import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import api from '../services/api';

function MahasiswaProfilPage({ user, onLogout, onBack }) {
  const [name, setName] = useState(user.name || '');
  const [email, setEmail] = useState(user.email || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    setLoading(true);
    try {
      await api.updateMahasiswaProfile({ name, email, password: password || undefined, currentPassword: currentPassword || undefined });
      setSuccess('Profil berhasil diupdate');
      setPassword(''); setCurrentPassword('');
    } catch (err) {
      setError(err.message || 'Gagal update profil');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <header className="app-header">
        <div className="header-container">
          <div className="header-left">
            <div className="header-logo">I-CARE</div>
            <div><h1 className="header-title">Profil Saya</h1><p className="header-subtitle">{user.name}</p></div>
          </div>
          <div style={{display:'flex',gap:'0.5rem'}}>
            <button onClick={onBack} className="btn-secondary">Kembali ke Penilaian</button>
            <button onClick={onLogout} className="btn-logout"><LogOut size={16}/><span>Logout</span></button>
          </div>
        </div>
      </header>
      <div className="content-container">
        <div className="card" style={{maxWidth:'480px'}}>
          {error && <div className="error-message">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <form onSubmit={handleSubmit}>
            <label className="form-label">Nama</label>
            <input className="period-input" value={name} onChange={e=>setName(e.target.value)} />
            <label className="form-label">Email</label>
            <input className="period-input" type="email" value={email} onChange={e=>setEmail(e.target.value)} />
            <label className="form-label">Password Lama (isi jika ingin ganti password)</label>
            <input className="period-input" type="password" value={currentPassword} onChange={e=>setCurrentPassword(e.target.value)} />
            <label className="form-label">Password Baru (kosongkan jika tidak ingin ganti)</label>
            <input className="period-input" type="password" value={password} onChange={e=>setPassword(e.target.value)} />
            <button className="btn-primary" type="submit" disabled={loading} style={{marginTop:'1rem'}}>Simpan</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MahasiswaProfilPage;
